import React from 'react';
import './style.css';
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import { NavLink } from "react-router-dom";

function TitleSection(props) {
  return (
    <Row>
      <Col lg={6} sm={6} md={6} xs={7}>
        <div className="title">
          <h2>{props.title}</h2>
        </div>
      </Col>
      <Col lg={6} sm={6} md={6} xs={5}>
        {props.Title_link &&
          <div className="Upcoming_Events" style={{ display: props.seeAll === "true" ? null : "none" }}>
            <NavLink  to={props.Title_link} activeClassName="see-all" >
              See All
            </NavLink>
          </div>
        }
      </Col>
    </Row>
  );
}

export default TitleSection;
